<template>
  <div class="icon-text">
    <CustomIcon :name="iconName" />
    <p>{{ text }}</p>
  </div>
</template>
<script>
import CustomIcon from "./CustomIcon.vue";
export default {
  props: {
    iconName: String,
    text: String,
  },
  components: { CustomIcon },
};
</script>
